import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStore } from '@core/auth/auth.store';

export const superAdminGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  if (authStore.isSuperAdmin()) {
    return true;
  }

  return router.createUrlTree([authStore.canSelectModule() ? '/selecionar-modulo' : '/vendas']);
};
